import React, { useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import html2pdf from "html2pdf.js";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentMemberReport } from "../app/features/memberReportSlice";
const customOrder = ["annual", "short-term", "long-term"];

const MembeReportPreview = () => {
  const card1Ref = useRef(null);
  const [loading, setLoading] = useState(false)
  const include = useSearchParams()[0].get("include");
  const fromDate = useSearchParams()[0].get("from");
  const formattedFromDate = fromDate ? new Date(fromDate.split('-')).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }) : null;
  const toDate = useSearchParams()[0].get("to");
  const formattedToDate = toDate ? new Date(toDate.split('-')).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }) : null;
  const asOnDate = useSearchParams()[0].get("asOn");
  const formattedAsOnDate = asOnDate ? new Date(asOnDate.split('-')).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }) : null;
  const includes = include.split(',').map(t => t.split('_').join(' '));
  const MemberReport = useSelector(selectCurrentMemberReport)

  const exportToPDF = () => {
    setLoading(true);
    // Combine the two cards into a wrapper for rendering
    const combinedRef = document.createElement("div");
    combinedRef.style.padding = "20px"; // Padding around the content
    combinedRef.style.backgroundColor = "white";
    combinedRef.style.width = "900px"; // Increase width of the PDF content

    // Clone and append the first card
    const card1Clone = card1Ref.current.cloneNode(true);
    card1Clone.style.marginBottom = "20px"; // Gap between cards
    card1Clone.style.width = "100%"; // Make sure card takes full width
    combinedRef.appendChild(card1Clone);

    // PDF Options
    const options = {
      margin: [10, 10], // Top and bottom margin
      filename: formattedAsOnDate
        ? `List-of-members-report(${new Date()
          .toISOString()
          .split("T")[0]
          .split("-")
          .reverse()
          .join("-")})`
        : `Member-status-report(${new Date()
          .toISOString()
          .split("T")[0]
          .split("-")
          .reverse()
          .join("-")})`,
      html2canvas: { scale: 2, width: 900 }, // Increase width
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .set(options)
      .from(combinedRef)
      .save()
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="pt-5 d-print-none">
        <div className="chapter-heading ">
          <h2 className="text-center title-font text-light py-3 mt-1">
            {formattedAsOnDate ? "List of Members" : "Membership Status Report"}
          </h2>
        </div>
      </div>
      <div className="p-md-5 p-3 overallPadding">
        <div className="text-end mb-3 d-print-none">
          <Button
            onClick={() => window.history.back()}
            variant="contained"
            className="menus-color"
          >
            Back
          </Button>
        </div>
        <div ref={card1Ref}>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow sx={{ bgcolor: "secondary.main" }}>
                  <TableCell
                    align="center"
                    colSpan={4}
                    className="border text-white"
                  >
                    {formattedAsOnDate
                      ? "List of Members"
                      : "Membership Status Report"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={1} className="border">
                    Report For
                  </TableCell>
                  <TableCell colSpan={2} className="border">
                    {MemberReport?.reportFor === 0
                      ? "The Association"
                      : MemberReport?.reportFor === 1
                        ? "Chapter: " + MemberReport.chapterName
                        : MemberReport?.reportFor === 2
                          ? "SIG: " + MemberReport.sigName
                          : "Location: " + MemberReport?.location}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={1} className="border">
                    Report for the period
                  </TableCell>
                  {formattedFromDate && (
                    <TableCell colSpan={2} className="border">
                      From {formattedFromDate} To {formattedToDate}
                    </TableCell>
                  )}
                  {formattedAsOnDate && (
                    <TableCell colSpan={2} className="border">
                      As On {formattedAsOnDate}
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: "secondary.main" }}>
                <TableRow>
                  <TableCell className="border text-white">
                    Membership Types
                  </TableCell>
                  <TableCell className="border text-white">
                    Membership Plans
                  </TableCell>
                  {includes.includes("New Membership") && (
                    <TableCell className="border text-white">New</TableCell>
                  )}
                  {includes.includes("Renewed Membership") && (
                    <TableCell className="border text-white">Renewal</TableCell>
                  )}
                  {includes.includes("Expired Membership") && (
                    <TableCell className="border text-white">Expired</TableCell>
                  )}
                  {includes.includes("Active Membership") && (
                    <TableCell className="border text-white">Active</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {MemberReport?.membershipSummary.map((report) => {
                  const normalize = (str) =>
                    str?.toLowerCase()?.replace(/\s+/g, " ").trim();

                  const sortedPlanTypes = [...report.planTypes].sort((a, b) => {
                    const normalizedA = normalize(a?.membershipPlan);
                    const normalizedB = normalize(b?.membershipPlan);

                    const indexA = customOrder.indexOf(normalizedA);
                    const indexB = customOrder.indexOf(normalizedB);
                    return (
                      (indexA === -1 ? Infinity : indexA) -
                      (indexB === -1 ? Infinity : indexB)
                    );
                  });
                  return sortedPlanTypes.map((plan, planIndex) => (
                    <TableRow key={planIndex}>
                      {/* {planIndex === 0 && <TableCell className="border" rowSpan={report?.entries.reduce((acc, item) => acc += item?.planTypes.length, 0)}>{index === 0 ? `${report.month} ${report.year}` : ""}</TableCell>} */}
                      {planIndex === 0 && (
                        <TableCell
                          className="border"
                          rowSpan={report.planTypes.length}
                        >
                          {" "}
                          {report.membershipType}
                        </TableCell>
                      )}
                      <TableCell className="border">
                        {plan.membershipPlan}
                      </TableCell>
                      {includes.includes("New Membership") && (
                        <TableCell className="border">
                          {plan.newCount}
                        </TableCell>
                      )}
                      {includes.includes("Renewed Membership") && (
                        <TableCell className="border">
                          {plan.renewalCount}
                        </TableCell>
                      )}
                      {includes.includes("Expired Membership") && (
                        <TableCell className="border">
                          {plan.expiredCount}
                        </TableCell>
                      )}
                      {includes.includes("Active Membership") && (
                        <TableCell className="border">
                          {plan.activeCount}
                        </TableCell>
                      )}
                    </TableRow>
                  ));
                })}
                <TableRow>
                  <TableCell className="border" align="right" colSpan={2}>
                    Total
                  </TableCell>
                  {includes.includes("New Membership") && (
                    <TableCell className="border">
                      {MemberReport?.totalCounts?.totalNewCount}
                    </TableCell>
                  )}
                  {includes.includes("Renewed Membership") && (
                    <TableCell className="border">
                      {MemberReport?.totalCounts?.totalRenewalCount}
                    </TableCell>
                  )}
                  {includes.includes("Expired Membership") && (
                    <TableCell className="border">
                      {MemberReport?.totalCounts?.totalExpiredCount}
                    </TableCell>
                  )}
                  {includes.includes("Active Membership") && (
                    <TableCell className="border">
                      {MemberReport?.totalCounts?.totalActiveCount}
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <p className="mt-3">
            {" "}
            <strong>Report Generated on :</strong>{" "}
            {new Date()
              .toISOString()
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-")}
          </p>
        </div>
        <div className="text-center mt-3">
          <Button
            onClick={exportToPDF}
            variant="contained"
            className="rounded-0 d-print-none"
            color="primary"
          >
            {loading ? "Generating PDF..." : "Download as PDF"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default MembeReportPreview;
